// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension="
// @generated from file common/v1/annotations.proto (package common.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenExtension, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2'
import { enumDesc, extDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2'
import type { MethodOptions } from '@bufbuild/protobuf/wkt'
import { file_google_protobuf_descriptor } from '@bufbuild/protobuf/wkt'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file common/v1/annotations.proto.
 */
export const file_common_v1_annotations: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Chtjb21tb24vdjEvYW5ub3RhdGlvbnMucHJvdG8SCWNvbW1vbi52MSKJAQoOQXV0aGVudGljYXRpb24SMAoGcG9saWN5GAEgASgOMiAuY29tbW9uLnYxLkF1dGhlbnRpY2F0aW9uLlBvbGljeSJFCgZQb2xpY3kSDwoLUE9MSUNZX05PTkUQABIVChFQT0xJQ1lfSUZfUFJFU0VOVBABEhMKD1BPTElDWV9SRVFVSVJFRBACIskBCg1BdXRob3JpemF0aW9uEisKBG1vZGUYASABKA4yHS5jb21tb24udjEuQXV0aG9yaXphdGlvbi5Nb2RlEhUKDXJlc291cmNlX25hbWUYAiABKAkSGwoTcmVxdWlyZWRfcGVybWlzc2lvbhgDIAEoCRIVCg1yZXNwb25zZV9ib2R5GAQgASgJIkAKBE1vZGUSFAoQTU9ERV9VTlNQRUNJRklFRBAAEhEKDU1PREVfUkVTVFJJQ1QQARIPCgtNT0RFX0ZJTFRFUhACOmMKDmF1dGhlbnRpY2F0aW9uEh4uZ29vZ2xlLnByb3RvYnVmLk1ldGhvZE9wdGlvbnMY2K0DIAEoCzIZLmNvbW1vbi52MS5BdXRoZW50aWNhdGlvblIOYXV0aGVudGljYXRpb246YAoNYXV0aG9yaXphdGlvbhIeLmdvb2dsZS5wcm90b2J1Zi5NZXRob2RPcHRpb25zGNmtAyABKAsyGC5jb21tb24udjEuQXV0aG9yaXphdGlvblINYXV0aG9yaXphdGlvbmIGcHJvdG8z',
    [file_google_protobuf_descriptor]
  )

/**
 * Authentication the authentication policy to use for a given method
 *
 * @generated from message common.v1.Authentication
 */
export type Authentication = Message<'common.v1.Authentication'> & {
  /**
   * The Authentication policy to use. Defaults to NONE
   *
   * @generated from field: common.v1.Authentication.Policy policy = 1;
   */
  policy: Authentication_Policy
}

/**
 * Describes the message common.v1.Authentication.
 * Use `create(AuthenticationSchema)` to create a new message.
 */
export const AuthenticationSchema: GenMessage<Authentication> =
  /*@__PURE__*/
  messageDesc(file_common_v1_annotations, 0)

/**
 * @generated from enum common.v1.Authentication.Policy
 */
export enum Authentication_Policy {
  /**
   * No attempt is made to parse the incoming credential
   *
   * @generated from enum value: POLICY_NONE = 0;
   */
  NONE = 0,

  /**
   * If the Authorization header is present it will be parsed, otherwise
   * the subject is considered unauthenticated
   *
   * @generated from enum value: POLICY_IF_PRESENT = 1;
   */
  IF_PRESENT = 1,

  /**
   * The Authorization header MUST be present
   *
   * @generated from enum value: POLICY_REQUIRED = 2;
   */
  REQUIRED = 2
}

/**
 * Describes the enum common.v1.Authentication.Policy.
 */
export const Authentication_PolicySchema: GenEnum<Authentication_Policy> =
  /*@__PURE__*/
  enumDesc(file_common_v1_annotations, 0, 0)

/**
 * Authorization the authorization policy to use for a given method
 *
 * @generated from message common.v1.Authorization
 */
export type Authorization = Message<'common.v1.Authorization'> & {
  /**
   * The authorization mode to use
   *
   * @generated from field: common.v1.Authorization.Mode mode = 1;
   */
  mode: Authorization_Mode

  /**
   * The name of the resource being accessed. This may contain interpolation
   * values representing paths into the request or response object depending on
   * the defined mode
   *
   * @generated from field: string resource_name = 2;
   */
  resourceName: string

  /**
   * The required permissions for performing the operation
   *
   * @generated from field: string required_permission = 3;
   */
  requiredPermission: string

  /**
   * The optional field in the response that holds the filtered result
   *
   * @generated from field: string response_body = 4;
   */
  responseBody: string
}

/**
 * Describes the message common.v1.Authorization.
 * Use `create(AuthorizationSchema)` to create a new message.
 */
export const AuthorizationSchema: GenMessage<Authorization> =
  /*@__PURE__*/
  messageDesc(file_common_v1_annotations, 1)

/**
 * @generated from enum common.v1.Authorization.Mode
 */
export enum Authorization_Mode {
  /**
   * @generated from enum value: MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Restrict access to the resource. This SHOULD be used for mutations and
   * GET operations
   *
   * @generated from enum value: MODE_RESTRICT = 1;
   */
  RESTRICT = 1,

  /**
   * Filter the results to those matching this policy. This SHOULD be used
   * for listing operations
   *
   * @generated from enum value: MODE_FILTER = 2;
   */
  FILTER = 2
}

/**
 * Describes the enum common.v1.Authorization.Mode.
 */
export const Authorization_ModeSchema: GenEnum<Authorization_Mode> =
  /*@__PURE__*/
  enumDesc(file_common_v1_annotations, 1, 0)

/**
 * @generated from extension: common.v1.Authentication authentication = 55000;
 */
export const authentication: GenExtension<MethodOptions, Authentication> =
  /*@__PURE__*/
  extDesc(file_common_v1_annotations, 0)

/**
 * @generated from extension: common.v1.Authorization authorization = 55001;
 */
export const authorization: GenExtension<MethodOptions, Authorization> =
  /*@__PURE__*/
  extDesc(file_common_v1_annotations, 1)
